import { Pipe, PipeTransform } from '@angular/core'

import { ChannelSourcesViewService } from '../services/view/channel-sources-view.service'

/**
 * Resuelve la KEY de canal (digital, interno, broker…) a su LABEL amigable del catálogo
 * (`channel_sources`): p.ej. `digital → "Canal Digital"`, `interno → "Plataforma"`.
 * Fuente de verdad = backend (mismo catálogo que usa el channel-badge), NO constantes.
 *
 * `pure: false` a propósito: el cache del catálogo (`ChannelSourcesViewService`) se llena
 * async vía `loadAll()`; un pipe puro no re-evaluaría al llegar los datos y dejaría el key
 * crudo. Impuro re-resuelve en cada CD (lookup O(1) en un Map) → siempre pinta la label.
 * Fallback al key capitalizado si el canal no está en cache (canal custom recién creado).
 */
@Pipe({ name: 'channelLabel', pure: false })
export class ChannelLabelPipe implements PipeTransform {
  constructor(private channels: ChannelSourcesViewService) {}

  transform(key: string | null | undefined): string {
    if (!key || key === 'N/A') return key ?? ''
    const label = this.channels.getByKey(key)?.label
    return label ?? key.charAt(0).toUpperCase() + key.slice(1)
  }
}
